var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
import { onError } from "@ane/core/lib/decorators/OnError";
import "../../../utils/FlightRoute.utils.js";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import { constructQueryString, getFlightQueryParams } from "@ane/exp-data/lib/routes/FlightRoute.utils";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
class CompositionResource extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.legacy, "/api/2.0/tenants/");
    __publicField(this, "_errorMessage", (RestResult2, response) => {
      return response && response.ExceptionMessage;
    });
  }
  _v2APIPath(tenantId) {
    return `${tenantId}/flights/`;
  }
  loadComposition(flightId, managementGroup, tenant, workspaceId) {
    return __async(this, null, function* () {
      const queryString = constructQueryString(getFlightQueryParams(managementGroup, workspaceId));
      const address = `${this._v2APIPath(tenant)}${flightId}/composition${queryString}`;
      const result = yield this._get(address);
      return result;
    });
  }
  loadDependency(flightId, managementGroup, tenant, workspaceId) {
    return __async(this, null, function* () {
      const result = yield this.tryLoadDepdency(flightId, managementGroup, tenant, workspaceId);
      return result;
    });
  }
  tryLoadDepdency(flightId, managementGroup, tenant, workspaceId) {
    return __async(this, null, function* () {
      const queryString = constructQueryString(getFlightQueryParams(managementGroup, workspaceId));
      const address = `${this._v2APIPath(tenant)}${flightId}/dependency${queryString}`;
      return yield this._get(address);
    });
  }
  updateCompositionBatch(managementGroup, tenant, workspaceId, updateRequest, verifyOnly, submitWithBlocking) {
    return __async(this, null, function* () {
      const baseAddress = `${this._v2APIPath(tenant)}composition/batch`;
      return this.updateCompositionShared(
        baseAddress,
        workspaceId,
        managementGroup,
        updateRequest,
        verifyOnly,
        submitWithBlocking
      );
    });
  }
  updateCompositionShared(baseAddress, workspaceId, managementGroup, updateRequest, verifyOnly, submitWithBlocking) {
    return __async(this, null, function* () {
      const verifyOnlyParam = `&verifyOnly=${verifyOnly ? "true" : "false"}`;
      const blockingParam = `&submitWithBlocking=${submitWithBlocking ? "true" : "false"}`;
      const params = [...getFlightQueryParams(managementGroup, workspaceId), verifyOnlyParam, blockingParam];
      const query = constructQueryString(params);
      const address = `${baseAddress}${query}`;
      const result = yield this._put(updateRequest, address);
      return result;
    });
  }
}
__decorateClass([
  onError({ message: `An error occurred while loading the flight's composition.` })
], CompositionResource.prototype, "loadComposition", 1);
__decorateClass([
  onError({ message: `An error occurred while loading the flight compositon's dependencies.` })
], CompositionResource.prototype, "loadDependency", 1);
__decorateClass([
  onError({ message: `An error occurred while updating the composition.` })
], CompositionResource.prototype, "updateCompositionBatch", 1);
const CompositionResource$1 = new CompositionResource();
export {
  CompositionResource$1 as default
};
//# sourceMappingURL=Composition.resource.js.map
